// Common or repeated strings
export const leadershipTranslations = {
    en: {
        viewBio: "View Bio",
    },
    "fr-FR": {
        viewBio: "Voir la bio",
    },
    "de-DE": {
        viewBio: "Biografie ansehen",
    },
    "it-IT": {
        viewBio: "Consulta la bio",
    },
    "ja-JP": {
        viewBio: "略歴",
    },
    "es-ES": {
        viewBio: "Ver Bio",
    },
    "pt-BR": {
        viewBio: "Ver Bio",
    },
};
